import React, { Component } from 'react';
import PageHelmet from './Helmet';
import Breadcrumb from './Breadcrumb';
import CounterOne from './CounterOne';
import Testimonial from './Testimonial';
import BrandTwo from './BrandTwo';
import { FaFacebookF, FaLinkedinIn, FaTwitter } from 'react-icons/fa';
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from 'react-icons/fi';
import Header from '../../../Layout/Main/header/Header';
import Footer from '../../../Layout/Main/footer/FooterTwo';

class Storage extends Component {
	render() {
		let title = 'Storage',
			description =
				'Whether you are reducing the size of your company, want temporary storage during your house search, or you need storage for any other purpose Moonline is the most suitable choice for you. We understand that it is difficult to leave your belongings in the hands of someone else. This is the reason that we hire only trusted and reliable staff members and keep an eye on your stuff all the time. So if you want a storage service for any of your belongings you can always trust our company because we treat your belongings like our own and take special care of them.';
		return (
			<React.Fragment>
				<PageHelmet pageTitle='Storage' />

				<Header headertransparent='header--transparent' colorblack='color--black' logoname='logo.png' />
				{/* Start Breadcrump Area */}
				{/* End Breadcrump Area */}

				{/* Start About Area  */}
				<div className='rn-about-area ptb--120 bg_color--1'>
					<div className='rn-about-wrapper'>
						<div className='container'>
							<div className='row row--35 align-items-center'>
								<div className='col-lg-7'>
									<div className='about-inner inner'>
										<div className='section-title'>
											<Breadcrumb title={'Storage'} />
											<h2 className='title'>{title}</h2>
											<p className='description'>{description}</p>
										</div>
										<div className='row mt--30'>
											<div className='col-lg-12 col-md-12 col-sm-12 col-12'>
												<div className='about-us-list'>
													<h3 className='title'>Why Choose Us as a Full-Service Storage Solution?</h3>
													<p>
														Many people think that self-storage is appealing as it seems simple and straightforward but there any many complexities and headaches in self-storage. It is also a less secure option to store your belongings. When you choose us for the storage
														of your possessions then we make sure to keep your products secure so that you can have peace of mind. In our partners’ storage facility, we provide the following services:
														<ul>
															<li>Professional staff to monitor your items</li>
															<li>24H monitoring with Video cameras.</li>
															<li>Managed inventories so that you can know what you have stored with us.</li>
															<li>Separate vaults for individual customers so that your belongings do not get mixed up with others.</li>
															<li>Enough room to store all your belongings.</li>
															<li>A secure system so that you can easily access and retrieve your items with proper appointment.</li>
															<li> Professional moving service to bring your belongings to your desired location when request.</li>
														</ul>
													</p>
												</div>
											</div>
											<div className='col-lg-12 col-md-12 col-sm-12 col-12'>
												<div className='about-us-list'>
													<h3 className='title'>What You Need to Know Before Storing Your Items?</h3>
													<p>There are certain things that you need to know before storing your items with us. We will help you to feel secure and comfortable and when you want to access your items you can access and retrieve them easily.</p>

													<p>You should always ask about the products that you are going to store in our partner’s facility that either they are allowed or not. Because there are some items that we do not store in our facility.</p>

													<p>You should ask about access hours before storing your goods in our facility. Not every facility allows you to access 24/7. So you must be aware of the accessing hours.</p>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				{/* Start Back To Top */}
				<div className='backto-top'>
					<ScrollToTop showUnder={160}>
						<FiChevronUp />
					</ScrollToTop>
				</div>
				{/* End Back To Top */}

				<Footer />
			</React.Fragment>
		);
	}
}
export default Storage;
